<template>
  <div class="main-wrapper" v-if="items">
    <form-search @search="btnSearchClick"></form-search>

    <el-table :data="items" :fit="true" stripe style="width: 100%">
      <el-table-column prop="createdDate" width="180" label="咨询时间"></el-table-column>
      <el-table-column prop="category" width="180" label="咨询类别"></el-table-column>
      <el-table-column label="咨询人" width="180">
        <template #default="scope">
          用户名：
          <span v-html="scope.row.userName"></span>
          <br />
          姓名：
          <span v-html="scope.row.name"></span>
          <br />
          公司：
          <span v-html="scope.row.company"></span>
          <br />
          手机：
          <span v-html="scope.row.mobile"></span>
          <br />
        </template>
      </el-table-column>
      <el-table-column label="咨询事宜">
        <template #default="scope">
          <span v-html="scope.row.content"></span>
        </template>
      </el-table-column>
      <el-table-column label="状态" width="120">
        <template #default="scope">
          <span v-if="scope.row.isReply" style="color: green">已回复</span>
          <span v-else style="color: red">待回复</span>
        </template>
      </el-table-column>
      <el-table-column label="备注" width="120">
        <template #default="scope">
          <span v-html="scope.row.memo"></span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="100">
        <template #default="scope">
          <el-link
            type="primary"
            style="margin-right: 5px"
            :underline="false"
            @click.prevent="btnReplyClick(scope.row)"
          >
            回 复
          </el-link>
          <el-link
            type="danger"
            style="margin-right: 5px"
            :underline="false"
            @click.prevent="btnDeleteClick(scope.row)"
          >
            删 除
          </el-link>
        </template>
      </el-table-column>
    </el-table>

    <el-row style="margin: 10px">
      <el-col :span="24" align="center">
        <el-pagination
          v-on:current-change="handleCurrentChange"
          :current-page="formSearch.currentPage"
          :page-size="formSearch.limit"
          layout="total, prev, pager, next, jumper"
          :total="count"
        ></el-pagination>
      </el-col>
    </el-row>

    <el-drawer title="咨询信息" direction="rtl" size="60%" v-model="isContact">
      <form-submit :contact="contact" @cancel="isContact = false" @submit="apiReply"></form-submit>
    </el-drawer>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { IContact } from '@/types/models';
import utils from '@/utils';
import api from '@/api/admin/contacts';
import FormSearch from './components/contacts/FormSearch.vue';
import FormSubmit from './components/contacts/FormSubmit.vue';

interface IFormSearch {
  currentPage: number;
  offset: number;
  limit: number;
  dateFrom: string;
  dateTo: string;
  keyword: string;
}

interface IState {
  items: IContact[];
  count: number;
  formSearch: IFormSearch;
  isContact: boolean;
  contact: IContact;
}

export default defineComponent({
  components: { FormSearch, FormSubmit },
  data() {
    return {
      items: [],
      count: 0,
      formSearch: {
        currentPage: 1,
        offset: 0,
        limit: 30,
        dateFrom: '',
        dateTo: '',
        keyword: '',
      },
      isContact: false,
      contact: {} as IContact,
    } as IState;
  },
  methods: {
    apiGet() {
      api.getContacts(
        {
          offset: this.formSearch.offset,
          limit: this.formSearch.limit,
          keyword: '',
          dateFrom: '',
          dateTo: '',
        },
        (res) => {
          if (!res) return;

          this.items = res.items;
          this.count = res.count;
        },
      );
    },

    apiDelete(contactId: number) {
      api.delete(
        {
          contactId,
        },
        (res) => {
          if (!res) return;

          this.apiGet();
        },
      );
    },

    apiReply(memo: string) {
      api.reply(
        {
          contactId: this.contact.id,
          memo,
        },
        (res) => {
          if (!res) return;

          utils.success('回复成功！');
          this.isContact = false;
          this.apiGet();
        },
      );
    },

    btnDeleteClick(contact: IContact) {
      utils.alertDelete(
        {
          title: '删除咨询',
          text: '此操作将会删除选中的咨询信息，确定吗？',
        },
        () => {
          this.apiDelete(contact.id);
        },
      );
    },

    btnSearchClick(form: { dateFrom: string; dateTo: string; keyword: string }) {
      this.formSearch = {
        ...form,
        currentPage: 1,
        offset: 0,
        limit: 30,
      };

      utils.loading(true);
      api.getContacts(this.formSearch, (res) => {
        if (!res) return;

        this.items = res.items;
        this.count = res.count;
      });
    },

    handleCurrentChange(val: number) {
      this.formSearch.currentPage = val;
      this.formSearch.offset = this.formSearch.limit * (val - 1);

      utils.loading(true);
      api.getContacts(this.formSearch, (res) => {
        if (!res) return;

        this.items = res.items;
        this.count = res.count;
      });
      utils.scrollTop();
    },

    btnReplyClick(contact: IContact) {
      this.isContact = true;
      this.contact = contact;
    },
  },
  mounted() {
    this.apiGet();
  },
});
</script>
